'use client';

import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren } from 'react';

import { User } from '@/.gql/graphql';
import { GET_USER } from '@/.graphql';

import { createCustomContext } from './context';

const [Context, useUserContext] = createCustomContext<User>({
  name: 'UserContext',
  strict: false,
});
export { useUserContext };

interface Props extends PropsWithChildren {
  userId: string;
}

export const UserProvider: FC<Props> = ({ children, userId }) => {
  const { data } = useSuspenseQuery(GET_USER, {
    variables: {
      userId,
    },
  });

  return <Context value={data.getUser!}>{children}</Context>;
};
